import React from 'react';
import api from '../api/client';
import TestimonialCard from '../components/TestimonialCard';
import withRouter from '../withRouter';

class ProductDetailPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { product: null, testimonials: [], loading: true, licenseType: 'shared' };
  }

  componentDidMount() {
    const { id } = this.props.params;
    Promise.all([api.getProduct(id), api.getTestimonials(id)])
      .then(([product, testimonials]) => this.setState({ product, testimonials, loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  handleAddToCart = () => {
    const { product, licenseType } = this.state;
    api.addToCart(product.id, licenseType, 1).then(() => {
      this.props.onCartChange && this.props.onCartChange();
      this.props.navigate('/cart');
    });
  };

  render() {
    const { product, testimonials, loading, licenseType } = this.state;
    if (loading) return <p className="loading">Loading...</p>;
    if (!product) return <p>Product not found.</p>;

    return (
      <div className="product-detail-page">
        <img src={product.image_url} alt={product.name} className="product-hero-image" />
        <h1>{product.name}</h1>
        <p className="vendor">{product.vendor}</p>
        <p>{product.description}</p>

        <div className="license-choice">
          <label>
            <input
              type="radio"
              checked={licenseType === 'shared'}
              onChange={() => this.setState({ licenseType: 'shared' })}
            />
            Shared license — ₦{Number(product.shared_price).toLocaleString()}
            <span className="save-badge">Save up to 50%</span>
          </label>
          <label>
            <input
              type="radio"
              checked={licenseType === 'private'}
              onChange={() => this.setState({ licenseType: 'private' })}
            />
            Private license — ₦{Number(product.full_price).toLocaleString()}
          </label>
        </div>

        <button className="btn btn-primary" onClick={this.handleAddToCart}>Add to cart</button>

        <section className="testimonials">
          <h2>Customer reviews</h2>
          {testimonials.length === 0 && <p>No reviews yet for this product.</p>}
          <div className="testimonial-grid">
            {testimonials.map((t, idx) => <TestimonialCard key={idx} testimonial={t} />)}
          </div>
        </section>
      </div>
    );
  }
}

export default withRouter(ProductDetailPage);
